// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1gF3N","footer":"Form_footer__2PyqZ"};